export const user = {
  name: 'Name',
  prename: 'Prename',
  profile: 'Profile',
  your_profile: 'Your profile',
};
